// Imports => React
import { useMemo, useState } from 'react';

// Imports => Constants
import {AcButton, AcSelectBox, THEMES, TYPES} from '@opp/ui-kit';

// Imports => Atoms
import {
  AcContainer,
  AcRow,
  AcColumn,
  AcRichContent,
} from '@opp/ui-kit';
import {withTranslation} from "react-i18next";
import {observer} from "mobx-react-lite";
import {withStore} from "../../stores";
import clsx from "clsx";

const _CLASSES = {
  MAIN: 'ac-filter-select-modal ac-modal--size-lg',
  CONTENT: 'ac-filter-select-modal__content',
};

const AcSettlementFilterModal = ({
  filters,
  defaultFilter,
  callback,
  t
}) => {

  const getContentClassNames = useMemo(() => {
    return clsx([_CLASSES.CONTENT]);
  }, []);

  const getStyleClassNames = useMemo(() => {
    return clsx([_CLASSES.MAIN]);
  }, []);

  const [localFilters, setLocalFilters] = useState(filters);

  const handleClearAll = (event) => {
    callback(defaultFilter)
  };

  const handleFilterChange = (name, value) => {
    setLocalFilters(value);
  };

  const getStatusSelectOptions = useMemo(() => {
    const options = [
      {value: 'all', name: `${t('filter.all', 'All', {ns: 'payouts'})}`},
      {value: 'current', name: `${t('status.current', {ns: 'payouts'})}`},
      {value: 'transfer', name: `${t('status.transfer', {ns: 'payouts'})}`},
      {value: 'invoiced', name: `${t('status.invoiced', {ns: 'payouts'})}`},
      {value: 'paid', name: `${t('status.paid', {ns: 'payouts'})}`},
      {value: 'cancelled', name: `${t('status.cancelled', {ns: 'payouts'})}`},
    ];

    return {
      type: TYPES.TEXT,
      label: `${t('filter.status', 'Choose a status', {ns: 'payouts'})}`,
      name: 'status',
      placeholder: `${t('filter.status', 'Choose a status', {ns: 'payouts'})}`,
      value: localFilters,
      callback: (event, name, value, type) => {
        handleFilterChange(name, value);
      },
      options,
    };
  }, [localFilters, localFilters.status]);

  const getClearFilterButtonOptions = useMemo(() => {
    return {
      type: TYPES.BUTTON,
      theme: THEMES.LIGHT,
      title: `${t('filter.clear-filter', 'Clear filter', {ns: 'payouts'})}`,
      callback: handleClearAll,
    };
  }, []);

  const getFilterButtonOptions = useMemo(() => {
    return {
      type: TYPES.SUBMIT,
      theme: THEMES.OMEGA,
      title: `${t('filter.filter', 'Filter', {ns: 'payouts'})}`,
      callback: () => { 
        callback(localFilters) 
      }
    };
  }, [localFilters]);

  return (
    <div className={getStyleClassNames}>
      <div className={getContentClassNames}>
        <AcContainer fluid>
          <AcRow className={'h-margin-y-40'}>
            <AcColumn xs={12} sm={12}>
              <AcSelectBox {...getStatusSelectOptions} />
            </AcColumn>
          </AcRow>

          <AcRow className={'h-margin-top-20'}>
            <AcColumn
              xs={5}
              sm={6}
              className={'h-text--align-left h-flex-v-align-center'}
            >
              <AcButton {...getClearFilterButtonOptions}>
                <span>{t('filter.clear-filter', 'Clear filter', {ns: 'payouts'})}</span>
              </AcButton>
            </AcColumn>
            <AcColumn xs={7} sm={6} className={'h-text--align-right'}>
              <AcButton {...getFilterButtonOptions}>
                <span>{t('filter.filter', 'Filter', {ns: 'payouts'})}</span>
              </AcButton>
            </AcColumn>
          </AcRow>

        </AcContainer>
      </div>
    </div>
  );
};

export default withTranslation(['payouts'])(withStore(observer(AcSettlementFilterModal)));
